import moment from 'moment';

import { useAuth } from 'contexts/AuthContext';

import s from './Footer.module.scss';

const Footer: React.FC = () => {
  const { state } = useAuth();

  return (
    <footer className={s.footer}>
      {state.user?.lastSignIn && (
        <div>
          Last Successful Login:{' '}
          {moment(state.user.lastSignIn.createdDateTime).format(
            'h:mm a, Do MMMM YYYY',
          )}
        </div>
      )}

      <div>Atlas Insurance | Claims Management Platform</div>
    </footer>
  );
};

export default Footer;
